import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStyles } from 'hooks'
import { Button } from 'reactstrap'
import { useCurrentContract, useBoolean } from 'hooks'
import { superFetch } from 'commons'
import { addNotification } from '../../notification'
import { useGetContractKAMNotification } from 'api/contract'
import moment from 'moment'

export const ContractKAMNotification: React.FC = () => {
  const { t } = useTranslation()
  const ctr = useCurrentContract()
  const { data: kamInfo } = useGetContractKAMNotification()

  const styles = useStyles((theme: any) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }))

  const callSendKAMNotification = (contractId: any) => {
    return superFetch({
      url: `contrats/kam/${contractId}/notification`,
      method: 'POST',
    })
  }

  const handleClick = React.useCallback(() => {
    const fetchData = async () => {
      const result = window.confirm(t('contract.kamNotification.confirmMessage'))
      if (result) {
        try {
          await callSendKAMNotification(ctr?.id)
          addNotification({
            type: 'success',
            title: '',
            message: t('contract.kamNotification.successMessage'),
          })
        } catch (error) {
          addNotification({
            type: 'danger',
            title: '',
            message: t('contract.kamNotification.errorMessage'),
          })
        }
      }
    }
    fetchData()
  }, [ctr?.id, t])

  if (kamInfo === null) {
    return (
      <div css={styles}>
        <p>{t('contract.kamNotification.noKamInfo')}</p>
      </div>
    )
  }

  return (
    <div css={styles}>
      <Button
        type="submit"
        css={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1.5rem',
          alignSelf: 'flex-start',
        }}
        onClick={handleClick}
      >
        {' '}
        {t('contract.kamNotification.buttonTitle')}
      </Button>
      <div>
        {kamInfo?.LastNotificationDate && (
          <p>
            {t('contract.kamNotification.lastNotificationDate')}:{' '}
            {moment(kamInfo.LastNotificationDate, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY HH:mm')}
          </p>
        )}
      </div>
    </div>
  )
}
